import React from "react";
import Bradcom from "../Bradcom/NosotrosB";
import Nosotros2 from "../Menhome/Nosotros2";
import Valores from "../Menhome/Valores";
import Luxury from "../Menhome/Luxury";
import Latest from "../Menhome/Latest";
import News from "../Menabout/News";
import { Helmet } from "react-helmet-async";

const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hotel La Finca Zotoluca | Nosotros</title>
        <meta
          name="description"
          content="Somos un proyecto nacido de la visión de Hacienda Zotoluca, combinando su riqueza histórica con un enfoque innovador en hospitalidad"
        />
      </Helmet>
      <main>
        <Bradcom title={"Nosotros"} subtitle={"Inicio"} newtitle={"Nosotros"} />
        <Nosotros2 />
        <Luxury />
        <Latest />
        <News />
        <Valores />
      </main>
    </>
  );
};

export default Main;
